"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { ArrowUp, Twitter, Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-primary/10 animate-pulse" />)}
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-200 font-default text-sm uppercase tracking-widest">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function InfoFooter() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <section data-section-id="228710" id="footer" className="bg-background text-foreground pt-20 pb-8 border-t-4 border-primary">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block w-max hover:opacity-80 transition-opacity">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/sti_group_logo_footer.png" alt="STI Group" className="h-7 object-contain" />
            </Link>
            <p className="text-muted-foreground font-default text-sm leading-relaxed max-w-xs">
              Singapore Time Innovation Investment Holding Group (STI Group) — a leading international investment group combining capital and innovation for global growth.
            </p>
            <div className="flex flex-col gap-2 mt-2">
              <div className="flex items-center gap-2 text-muted-foreground text-sm font-mono">
                <MapPin className="size-4 text-primary" />
                <span>346C KING GEORGE'S AVENUE, SINGAPORE 208577</span>
              </div>
              
              <div className="flex items-center gap-2 text-muted-foreground text-sm font-mono">
                <Mail className="size-4 text-primary" />
                <span>rickychen@stiholdinggroup.com</span>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            
            <MenuProvider menu_id="251">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            
            <ul className="flex flex-col gap-3">
              {[{
              label: "Privacy Policy",
              path: "#"
            }, {
              label: "Terms of Use",
              path: "#"
            }, {
              label: "Compliance",
              path: "#"
            }, {
              label: "For Investors",
              path: "#"
            }].map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.path} className="text-muted-foreground hover:text-primary transition-colors duration-200 font-default text-sm uppercase tracking-widest">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          

        </div>

        {}
        <div className="pt-8 border-t-2 border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground font-mono text-xs uppercase tracking-widest">© 2024 STI GROUP. All rights reserved.</p>
          
          <Button variant="outline" size="icon" onClick={scrollToTop} className="border-2 border-primary/20 bg-transparent text-primary hover:bg-primary hover:text-primary-foreground transition-colors" aria-label="Наверх">
            <ArrowUp className="size-4" />
          </Button>
        </div>
      </div>
    </section>;
}